import React from 'react';

const Skeleton = ({ lines = 3, height = 14, radius = 8, style = {} }) => {
  const items = Array.from({ length: lines });
  return (
    <div aria-busy="true" aria-live="polite" style={{ display: 'grid', gap: 10, ...style }}>
      {items.map((_, i) => (
        <div
          key={i}
          style={{
            width: '100%',
            height,
            background: 'linear-gradient(90deg, rgba(255,255,255,0.08), rgba(255,255,255,0.15), rgba(255,255,255,0.08))',
            backgroundSize: '200% 100%',
            animation: 'skeleton-shimmer 1.6s infinite',
            borderRadius: radius,
          }}
        />
      ))}
      <style>{`
        @keyframes skeleton-shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
    </div>
  );
};

export default Skeleton;

